import { Action, createReducer, on } from '@ngrx/store';
import { AppointmentStatusGridData } from '../shared/models/AppointmentStatusGridData';
import * as MessageHubActions from '../../../state/actions/message-hub.actions';
import * as AppointmentStatusGridActions from './actions/appointment-status-grid.actions';

export interface AppointmentStatusGridState {
    searchText: string;
    gridData: AppointmentStatusGridData;
    tenantId: number;
    locationId: number;
    page: number;
    pageSize: number;
    sortColumn: string;
    sortDirection: string;
    fromUtcDateString: string;
    toUtcDateString: string;
    subscribeToAppointmentStatusGridData: boolean;
}

const date = new Date();
const todayFrom = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
date.setDate(date.getDate() + 1);
const todayTo = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);

const initialAppointmentStatusGridState: AppointmentStatusGridState = {
    searchText: '',
    gridData: {
        totalRowCount: 0,
        data: [],
        currentPageNumber: 1,
        pageSize: 25,
        numberOfPages: 0
    },
    tenantId: 1,
    locationId: 0,
    page: 1,
    pageSize: 25,
    sortColumn: '',
    sortDirection: '',
    fromUtcDateString: todayFrom.toISOString(),
    toUtcDateString: todayTo.toISOString(),
    subscribeToAppointmentStatusGridData: true
};

const reducer = createReducer<AppointmentStatusGridState>(
    initialAppointmentStatusGridState,
    on(MessageHubActions.receivedAppointmentGridData, (appoimentStatusGridState, action): AppointmentStatusGridState => (
        {
            ...appoimentStatusGridState,
            gridData: (action.messageData !== '') ? JSON.parse(action.messageData) : {}
        }
    )),
    on(AppointmentStatusGridActions.setAppointmentStatusGridPagination, (appoimentStatusGridState, action): AppointmentStatusGridState => (
        {
            ...appoimentStatusGridState,
            page: action.page,
            pageSize: action.pageSize,
            subscribeToAppointmentStatusGridData: true
        }
    )),
    on(AppointmentStatusGridActions.setAppointmentStatusGridSortOptions, (appoimentStatusGridState, action): AppointmentStatusGridState => (
        {
            ...appoimentStatusGridState,
            sortColumn: (action.sortDirection === undefined) ? '' : action.sortColumn,
            sortDirection: (action.sortDirection === undefined) ? '' : (action.sortDirection === 'asc') ? 'asc' : 'desc',
            subscribeToAppointmentStatusGridData: true
        }
    )),
    on(MessageHubActions.joinAppointmentStatusGridActionComplete, (appoimentStatusGridState, action): AppointmentStatusGridState => (
        {
            ...appoimentStatusGridState,
            subscribeToAppointmentStatusGridData: false
        }
    )),
    on(AppointmentStatusGridActions.setAppointmentStatusGridSearchFilter,
        (appoimentStatusGridState, action): AppointmentStatusGridState => (
        {
            ...appoimentStatusGridState,
            searchText: action.searchFilter,
            subscribeToAppointmentStatusGridData: true
        }
    )),
    on(AppointmentStatusGridActions.removeAppointmentStatusGridSearchFilter,
        (appoimentStatusGridState, action): AppointmentStatusGridState => (
        {
            ...appoimentStatusGridState,
            searchText: '',
            subscribeToAppointmentStatusGridData: true
        }
    )),
    on(AppointmentStatusGridActions.setSubscribeToAppointmentStatusGrid,
        (appoimentStatusGridState, action): AppointmentStatusGridState => (
        {
            ...appoimentStatusGridState,
            subscribeToAppointmentStatusGridData: true
        }
    )),
    on(AppointmentStatusGridActions.setAppointmentStatusGridLocation,
      (appoimentStatusGridState, action): AppointmentStatusGridState => (
      {
          ...appoimentStatusGridState,
          locationId: action.locationId,
          subscribeToAppointmentStatusGridData: true
      }
  )),

  on(AppointmentStatusGridActions.setAppointmentStatusGridTenantId,
    (appoimentStatusGridState, action): AppointmentStatusGridState => (
    {
        ...appoimentStatusGridState,
        tenantId: action.tenantId,
        subscribeToAppointmentStatusGridData: true
    }
)),
on(AppointmentStatusGridActions.setAppointmentStatusFromDate,
    (appoimentStatusGridState, action): AppointmentStatusGridState => (
    {
        ...appoimentStatusGridState,
        fromUtcDateString: action.fromDate,
        toUtcDateString: action.toDate,
        subscribeToAppointmentStatusGridData: true
    }
)),
on(AppointmentStatusGridActions.setAppointmentStatusToDate,
    (appoimentStatusGridState, action): AppointmentStatusGridState => (
    {
        ...appoimentStatusGridState,
        toUtcDateString: action.toDate,
        subscribeToAppointmentStatusGridData: true
    }
)),
);

export function appointmentStatusGridReducer(state: AppointmentStatusGridState | undefined, action: Action) {
    return reducer(state, action);
}
